export default "__VITE_ASSET__DOo0XYJn__"